import { z } from 'zod'
import { FeedEventSource } from '../segment.types'

export const callStartedSchema = z.object({
  masterTaskId: z.string(),
  taskList: z.array(z.object({
    uuid: z.string(),
    type: z.string(),
  })),
  source: z.enum([FeedEventSource.CHART, FeedEventSource.SIDEBAR]),
})
